export interface Team {
    id: string;
    nombre: string;
    logo?: string;
    color?: string;
    puntos?: string | number;
    confederacion?: string;
    equipo?: string;
    comp_id?: string;
    comp_nombre?: string;
}

export interface Player {
    id: string;
    nombre: string;
    posicion?: string;
    segPosicion?: string;
    posicionSecundaria?: string;
    numero?: string | number;
    num?: string | number;
    nacimiento?: string;
    birthday?: string;
    lm?: string;
    nacionalidad?: string;
    ciudad?: string;
    nacionalidad2?: string;
    equipo_id?: string;
    comp_id?: string;
    img?: string;
}



export interface PlayerStatistics {
    passingAttempts: number;
    passingCompletions: number;
    passingYards: number;
    passingTouchdowns: number;
    interceptionsThrown: number;

    rushingAttempts: number;
    rushingYards: number;
    rushingTouchdowns: number;

    receptions: number;
    receivingYards: number;
    receivingTouchdowns: number;

    soloTackles: number;
    assistedTackles: number;
    sacks: number;
    assistedSacks: number;
    interceptions: number;
    forcedFumbles: number;
    recoveredFumbles: number;
    defensiveTouchdowns: number;
    passDeflections: number;

    fieldGoalsMade: number;
    fieldGoalsAttempted: number;
    extraPointsMade: number;
    extraPointsAttempted: number;
    longestFieldGoal: number;

    gamesPlayed: number;
}


export interface Competition {
    id: string;
    nombre: string;
    logo?: string;
    confederacion?: string;
    puntos?: string | number;
    sede?: string;
    fechaI?: string;
    fechaF?: string;
    jornadas?: string | number;
}

export interface Game {
    id: string;
    id_comp: string;
    id_local: string;
    id_visita: string;
    nombre_local: string;
    nombre_visita: string;
    resLocal?: string | number;
    resVisita?: string | number;
    fecha?: string;
    jornada?: string | number;
    partido?: string;
    sede?: string;
}

export interface CompetitionTeam {
    id: string;
    nombre: string;
    grupo?: string;
}

export interface CompetitionGame {
    id: string;
    id_comp: string;
    id_local: string;
    nombre_local?: string;
    id_visita: string;
    nombre_visita?: string;
    partido?: string;
    sede?: string;
    fecha?: string;
    resLocal?: string | number;
    resVisita?: string | number;
    jornada?: string | number;
    overUnder?: string;
    spread?: string;
    ml?: string;
}

export interface PlayerSummary extends Player {
    [key: string]: unknown;
}

export type PlayersById = Record<string, PlayerSummary>;

export async function getPlayers(
    forceRefresh = false
): Promise<PlayersById> {
    return getJson<PlayersById>(
        "jugadores.json",
        forceRefresh
    );
}

export async function getPlayersList(
    forceRefresh = false
): Promise<Player[]> {
    const playersById = await getPlayers(forceRefresh);

    return Object.values(playersById);
}
export interface PlayerHistoryEntry {
    posicion?: string;
    numero?: string;
    equipo_id?: string;
    equipo_nombre?: string;
    comp_id?: string;
    comp_nombre?: string;
    fecha?: string;
}

export interface PlayerDetail {
    Info: PlayerSummary;
    Historial?:
        | PlayerHistoryEntry[]
        | Record<string, PlayerHistoryEntry>;
}

export async function getPlayerDetail(
    playerId: string,
    forceRefresh = false
): Promise<PlayerDetail> {
    return getJson<PlayerDetail>(
        `${encodeURIComponent(playerId)}.json`,
        forceRefresh
    );
}

export interface User {
    id: string;
    username: string;
    nombre?: string;
    apellidos?: string;
    favorito?: string;
}

type UsersResponse = Record<string, User>;

export async function getFavoriteTeamId(
    username: string,
    forceRefresh = false
): Promise<string | null> {
    const usersData = await getJson<UsersResponse>(
        "usuarios.json",
        forceRefresh
    );

    const user =
        usersData[username] ||
        Object.values(usersData).find(function (currentUser) {
            return currentUser.username === username;
        });

    return user?.favorito ? String(user.favorito) : null;
}




export interface GamePlay {
    [key: string]: string | undefined;

    q?: string;
    jugada?: string;
    ofensiva?: string;

    QB?: string;
    RB?: string;
    WR?: string;
    K?: string;

    yds?: string;
    ydsI?: string;
    ydsF?: string;
    ydsPitch?: string;

    td?: string;
    deftd?: string;
    retTd?: string;
    retYds?: string;

    int?: string;
    sack?: string;
    assSack?: string;
    assSackk?: string;

    tkl?: string;
    assTkl?: string;
    assTkll?: string;

    fumbleF?: string;
    fumbleR?: string;

    ret?: string;
    pitch?: string;
    pf?: string;

    d?: string;
    side?: string;
    od?: string;

    C?: string;
    c?: string;
    playerC?: string;

    completo?: string;
    longPass?: string;
    passDef?: string;
    kickBlq?: string;
    muff?: string;

    k?: string;

}


export interface GameDetail {
    Data: CompetitionGame;
    Jugadas?: GamePlay[] | Record<string, GamePlay>;
}

export async function getGameDetail(
    gameId: string,
    forceRefresh = false
): Promise<GameDetail> {
    return getJson<GameDetail>(
        `${encodeURIComponent(gameId)}.json`,
        forceRefresh
    );
}
export interface TeamDetailInfo {
    id: string;
    nombre: string;
    confederacion?: string;
    logo?: string;
    color?: string;
    puntos?: string;
    equipo?: string;
    comp_id?: string;
    comp_nombre?: string;
}

export interface TeamDetail {
    Info: TeamDetailInfo;
    Partidos?: CompetitionGame[] | Record<string, CompetitionGame>;
}

export async function getTeamDetail(
    teamId: string,
    forceRefresh = false
): Promise<TeamDetail> {
    return getJson<TeamDetail>(
        `${encodeURIComponent(teamId)}.json`,
        forceRefresh
    );
}

export interface CompetitionDetail {
    Info: Competition;
    Grupos?: {
        equipos?: string | number;
        grupos?: string | number;
    };
    Equipos: Record<string, CompetitionTeam>;
    Partidos: Record<string, CompetitionGame>;
    Final?: Record<string, CompetitionGame>;
}

const DATA_ROOT = `${process.env.PUBLIC_URL || ""}/data`;

const requestCache = new Map<string, Promise<unknown>>();

function objectToArray<T>(data: Record<string, T> | T[]): T[] {
    if (Array.isArray(data)) {
        return data.filter(Boolean);
    }

    return Object.values(data || {}).filter(Boolean);
}

async function getJson<T>(
    endpoint: string,
    forceRefresh = false
): Promise<T> {
    const baseUrl = `${DATA_ROOT}/${endpoint}`;
    const cacheKey = baseUrl;

    /*
        Al actualizar, se elimina la promesa anterior y se agrega
        un timestamp para obligar al navegador a descargar JSON nuevo.
    */
    if (forceRefresh) {
        requestCache.delete(cacheKey);
    }

    if (!requestCache.has(cacheKey)) {
        const separator = baseUrl.includes("?") ? "&" : "?";

        const requestUrl = forceRefresh
            ? `${baseUrl}${separator}t=${Date.now()}`
            : baseUrl;

        const request = fetch(requestUrl, {
            cache: forceRefresh ? "no-store" : "default"
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error(
                        `No fue posible cargar ${endpoint}. Código: ${response.status}`
                    );
                }

                return response.json() as Promise<T>;
            })
            .catch(function (error) {
                requestCache.delete(cacheKey);
                throw error;
            });

        requestCache.set(cacheKey, request);
    }

    return requestCache.get(cacheKey) as Promise<T>;
}



export async function getCompetitions(
    forceRefresh = false
): Promise<Competition[]> {
    const competitionsData = await getJson<
        Record<string, Competition> | Competition[]
    >("competencias.json", forceRefresh);

    return objectToArray<Competition>(competitionsData);
}

export async function getHomeData(forceRefresh = false): Promise<{
    games: Game[];
    teams: Team[];
    competitions: Competition[];
}> {
    const [gamesData, teamsData, competitionsData] = await Promise.all([
        getJson<Record<string, Game> | Game[]>(
            "partidos.json",
            forceRefresh
        ),
        getJson<Record<string, Team> | Team[]>(
            "equipos.json",
            forceRefresh
        ),
        getJson<Record<string, Competition> | Competition[]>(
            "competencias.json",
            forceRefresh
        )
    ]);

    return {
        games: objectToArray<Game>(gamesData),
        teams: objectToArray<Team>(teamsData),
        competitions: objectToArray<Competition>(competitionsData)
    };
}

export async function getCompetitionDetail(
    competitionId: string,
    forceRefresh = false
): Promise<CompetitionDetail> {
    return getJson<CompetitionDetail>(
        `${encodeURIComponent(competitionId)}.json`,
        forceRefresh
    );
}
export async function getTeams(
    forceRefresh = false
): Promise<Team[]> {
    const teamsData = await getJson<Record<string, Team> | Team[]>(
        "equipos.json",
        forceRefresh
    );

    return objectToArray<Team>(teamsData);
}

export async function getGames(
    forceRefresh = false
): Promise<Game[]> {
    const gamesData = await getJson<Record<string, Game> | Game[]>(
        "partidos.json",
        forceRefresh
    );

    return objectToArray<Game>(gamesData);
}